<div class="navbar">

  <a *ngIf="!rolesService.isOnlyNotifications()"
     gp-open-modal
     modalId="aside"
     class="navbar-item toggle-aside pull-left hidden-lg-up">
    <i class="fa-solid fa-bars"></i>
  </a>

  <!-- Client brand (logo + name) — left side of the unified top navbar -->
  <a class="navbar-brand-merged" *ngIf="user" test-id="navbar-brand">
    <img *ngIf="navLogoURL"
         [attr.src]="navLogoURL"
         [alt]="user.companyName"
         class="navbar-brand-merged__logo"
         test-id="navbar-logo">
    <span class="navbar-brand-merged__name">{{ user.companyName }}</span>
  </a>

  <gp-context-bar class="navbar-context context-bar hidden-sm-down"></gp-context-bar>

  <div gp-roles
       [userRoles]="['SEARCH']"
       class="navbar-search collapse navbar-toggleable-sm hidden-sm-down"
       [class.in]="collapsedOpen">
    <form class="navbar-form pull-left form-inline navbar-item v-m">
      <div class="form-group l-h m-a-0">
        <div class="input-group input-group-sm" (click-outside)="clear()">
          <span class="input-group-btn">
            <button type="submit" class="btn btn-sm btn-default b-a no-shadow">
              <em *ngIf="!isLoading" class="fa fa-light fa-search"></em>
              <em *ngIf="isLoading" class="fa fa-light fa-spinner fa-spin"></em>
            </button>
          </span>
          <input type="text"
                 class="form-control b-a form-group-sm search-field"
                 placeholder="{{ 'NAVBAR.search' | translate }} ..."
                 [formControl]="searchTerm">
          <ul class="dropdown-menu search-results list" [attr.data-hidden]="!searchResults.length"
              [class.l-h-250]="searchResults.length > 5">
            <li *ngFor="let result of searchResults" (click)="open(result)" class="list-item">
              <div class="list-left">
              <gp-user-avatar *ngIf="result.employee"
                                [pictureUri]="result | gpEmployeePhotoUri"
                                [initials]="getSearchResultInitials(result)">
                </gp-user-avatar>
                <gp-user-avatar *ngIf="result.entity"
                                classes="avatar-accent"
                                [initials]="getSearchResultInitials(result)">
                </gp-user-avatar>
              </div>
              <div class="list-body">
                <div class="m-t-xs text-ellipsis" [title]="result.name + ' (' + result.displayedId + ')'">
                  {{ result.name + ' (' + result.displayedId + ')' }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </form>
  </div>

  <ul class="nav navbar-nav">
    <li class="nav-item dropdown"
        *ngIf="displayAsyncInfos"
        [popover]="asyncProcessesRunningTooltip"
        popoverTitle="{{ 'NAVBAR.ASYNC_PROCESSES_RUNNING' | translate}}"
        placement="bottom"
        container="body"
        triggers="mouseenter:mouseleave">
      <a class="nav-link" test-id="navbar-async-process">
        <em class="fa fa-light fa-cog"
            [class.fa-spin]="hasAsyncProcessesRunning()"
            [class.text-muted]="!hasAsyncProcessesRunning()"></em>
      </a>
    </li>
    <ng-template #asyncProcessesRunningTooltip>
      <ul *ngIf="hasAsyncProcessesRunning(); else noProcessRunning" class="list-group list-group-flush text-left">
        <li *ngFor="let asyncProcessRunning of asyncProcessesRunning" class="list-group-item">
          <em class="fa fa-light fa-cog fa-spin"></em>&nbsp;
          <span>{{ 'NAVBAR.ASYNC_PROCESS_' + asyncProcessRunning | translate}}</span>
        </li>
      </ul>
      <ng-template #noProcessRunning>
        <p>{{ 'NAVBAR.NO_ASYNC_PROCESS_RUNNING' | translate}}</p>
      </ng-template>
    </ng-template>

    <!-- Alerts / bell -->
    <li class="nav-item dropdown"
        *ngIf="!rolesService.isAccessLimited()"
        (mouseenter)="showNotificationCard(true)"
        (mouseleave)="showNotificationCard(false)">
      <a [routerLink]="['/inbox/notifications']" class="nav-link" test-id="navbar-notifications">
        <em class="fa fa-light fa-bell fa-xl"></em>
        <span *ngIf="communicationsService.informationUnreadCount > 0"
              class="label rounded up danger"
              [style.line-height]="communicationsService.informationUnreadCount > 9 ? '1.7' : '1'">
            {{ communicationsService.informationUnreadCount }}
            </span>
      </a>
      <gp-communications-card class="dropdown-menu dropdown-menu-scale"
                              [class.visible]="!isMobile && isNotificationsVisible"
                              (click)="showNotificationCard(false)">
      </gp-communications-card>
    </li>

    <!-- Help icon -->
    <li class="nav-item dropdown" *ngIf="knowledgeUri">
      <a (click)="openKnowledge()" class="nav-link" href="#">
        <em class="fa fa-light fa-question-circle fa-xl"></em>
      </a>
    </li>

    <!-- AI Assistant Icon -->
    <li class="nav-item dropdown"
        gp-roles [userRoles]="['AI_ASSISTANT']"
        *ngIf="!isMobile"
        (mouseenter)="isHovered = true"
        (mouseleave)="isHovered = false">

      <a class="nav-link" (click)="toggleChatbot()"
         test-id="navbar-chatbot-button">
        <em class="fa-solid fa-sparkles fa-xl"
            [ngClass]="{'fa-fade': isHovered}">
        </em>
      </a>
    </li>

    <!-- User menu -->
    <li class="nav-item nav-user-menu">
      <span class="nav-link dropdown-toggle clear pointer"
            *ngIf="user"
            test-id="navbar-user-menu"
            (click)="profileDrawerOpen = true">
        <span class="hidden-md-down nav-text m-r-sm text-right">
          <span class="block l-h-1x _500 text-capitalize nav-user-name">{{ user?.fullName }}</span>
          <small class="block l-h-1x nav-user-connection" *ngIf="user.lastConnection">
            {{ 'NAVBAR.last_connection' | translate:{
            value: user.lastConnection | gpDate: {
              format: 'LLL',
              timezone: this.user.timezone
            }
          } }}
          </small>
        </span>
        <gp-user-avatar [pictureUri]="employee?.photoLink?.href"
                        [initials]="getNavInitials()"></gp-user-avatar>
      </span>
    </li>

    <!-- More menu (smaller screens) -->
    <li class="nav-item hidden-xs-up">
      <a class="nav-link collapsed" (click)="collapsedOpen = !collapsedOpen">
        <i class="fa-solid fa-ellipsis-vertical"></i>
      </a>
    </li>

  </ul>


  <!-- Account preferences drawer (opened from the user name/avatar) -->
  <gp-profile-drawer [(open)]="profileDrawerOpen"
                     [canChangePassword]="(user?.cliCoreId !== 1000004 && user?.ssoType !== 'IPS_SSO' && user?.ssoType !== 'GP_SSO') || user?.cliEmpId == null"
                     (logout)="logout()"
                     (changePassword)="changePassword()">
  </gp-profile-drawer>

</div>
